<template>
    <button style="width: 100%; height: 100%; padding: 5px 10px;background-color: #d9d9d9; border-radius:30px; display:flex; align-items: center; justify-content: center;" @click="handlerClick()">
        <span style="color: #1d1d1e; font-family: Roboto; font-weight: 400; font-size: 13px;">{{is_activate_filter?$t("AddFilterDocuments.see_invoices"):$t("AddFilterDocuments.add_filter")}}</span>
        <v-icon v-if="is_activate_filter" size="15px" style="margin-left: 7px;">mdi-eye</v-icon>
        <AppIcon :src="require('@/assets/add_gray.svg')" :size="29" style="height: 13px; width: 13px; margin-left: 7px;" v-else />
    </button>
</template>

<script>

export default{
    name: "AddFilterDocuments",
    data(){
        return{
            is_activate_filter: false
        }
    },
    methods: {
        handlerClick(){
            this.is_activate_filter = !this.is_activate_filter
            this.$emit("add-filter-clicked")
        }
    }
}
</script>
